// DS7.4.1
// for sales there is a specialized version - da-shared-react/SaleBanner
// for monetization promos (tiers, commissions) there is - da-shared-react/MonetizationStrip
// There is PromoBannerMobile with a bit different layout
// but in many cases PromoBanner is used on mobile as well
import React from 'react';
import c from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { ThemeOptions, ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import GhostButton from '../Buttons/GhostButton';
import PlainButtonOrLink from '../Buttons/PlainButtonOrLink';
import s from './PromoBanner.scss';
const PromoBanner = ({ className , messageClassName , size , variant , messageBeforeIcon , icon , messageAfterIcon , ctaLabel , ctaHref , ctaOnClick , ctaBiData  })=>{
    const redesigned_money_banners = useFlag('redesigned_money_banners');
    const renderCtaButton = ()=>{
        if (!ctaLabel) {
            return;
        }
        if (size === 'small') {
            return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
                className: s['text-link'],
                href: ctaHref,
                onClick: ctaOnClick,
                biData: ctaBiData
            }, ctaLabel);
        }
        return /*#__PURE__*/ React.createElement(GhostButton, {
            size: "small",
            variant: "main",
            className: s['button'],
            href: ctaHref,
            onClick: ctaOnClick,
            biData: ctaBiData
        }, ctaLabel);
    };
    const renderLayout = ()=>/*#__PURE__*/ React.createElement("div", {
            className: s['layout']
        }, messageBeforeIcon && /*#__PURE__*/ React.createElement("div", {
            className: s['message-before-icon']
        }, messageBeforeIcon), icon && /*#__PURE__*/ React.createElement("div", {
            className: s['icon']
        }, icon), /*#__PURE__*/ React.createElement("div", {
            className: c(s['message-after-icon-and-button'], messageClassName)
        }, /*#__PURE__*/ React.createElement("div", {
            className: s['message-after-icon']
        }, messageAfterIcon), renderCtaButton()));
    const rootClassnames = c(s['root'], redesigned_money_banners && s['redesigned-money-banners'], s[`size-${size}`], s[`variant-${variant}`], className);
    switch(variant){
        case 'core':
        case 'daprotect':
            return /*#__PURE__*/ React.createElement(ThemeOverride, {
                className: rootClassnames,
                theme: ThemeOptions.LIGHT
            }, renderLayout());
        case 'artist':
        case 'shop':
            return /*#__PURE__*/ React.createElement(ThemeOverride, {
                className: rootClassnames,
                theme: ThemeOptions.DARK
            }, renderLayout());
        case 'subscription':
        case 'monetize':
            return /*#__PURE__*/ React.createElement("div", {
                className: rootClassnames
            }, renderLayout());
        default:
            return null;
    }
};
PromoBanner.displayName = 'PromoBanner';
export default PromoBanner;
